export type OpenedModalEntry<Configs, T extends keyof Configs> = {
  id: string
  type: T
  // TODO(ZE-431): We should migrate all the modal renderers to include onDismiss by default
  // so we can remove Omit<Configs[T], 'onDismiss'>
  config: Configs[T] | Omit<Configs[T], 'onDismiss'>
}

export interface IModalState<Configs> {
  openedModals: OpenedModalEntry<Configs, keyof Configs>[]
}

/**
 *
 */
export function createModalState<Configs>(): IModalState<Configs> {
  return {
    openedModals: [],
  }
}
